<template>
<div class="exo-2">
    <!-- @mouseenter.prevent.once="bgChange" @touchstart.once="bgChange" -->
    <div>
        <!-- :class="activeBg" -->
        <div class="h-100 w-100 bg-fixed bg-jane">
            <div class="w-100 pa2 flex items-center flex-column">
                <img src="../assets/FitBeastInverse.png" alt="FitBeastLogo" class="">
            </div>
            <div class="w-100 w-50-ns fr-ns pa4 pt0 exo-2">
                <p class="f3 white"> Join now </p>
                <p class="f-subheadline-ns f2 b white mb4 mt1">Fitness <span class="underline">Redefined</span></p>
                <p class="f5 white">More energy. More strength. More results. Just MORE</p>
                <button class="pl5 pr5 pt3 pb3 bg-red bw0 grow pointer white exo-2" @click.prevent="formDisplay = !formDisplay">Let's do this!</button>
            </div>
        </div>
        <div class="fl w-100 h-100 bg-white near-black pb5">
            <div class="fl w-100 flex flex-column items-center pt3 mt5 mb5">
                <h1 class="w-50-ns pl0-ns pl3 tc f-subheadline-ns f1 mt0 pt3 pb3 fl bl bw2">Our <span class="underline red">Programs</span></h1>
            </div>
            <div class="flex-ns w-100">
                <div class="w-100 w-third-ns pa3 mr2">
                    <img src="../assets/Group.png" alt="">
                    <p class="tc f6 pa3 hidden hidden-bottom muli b" v-infocus="'showElement'">Large selection of classes ranging from high-intensity boot camps, cycling, metabolic conditioning, barre, yoga, dance, boxing, and more. </p>
                    <h4 class="f3 tc red hidden hidden-bottom" v-infocus="'showElement'">Group Fitness</h4>
                </div>
                <div class="w-100 w-third-ns pa3 mr2">
                    <img src="../assets/Corporate.png" alt="">
                    <p class="tc f6 pa3 hidden hidden-bottom muli b" v-infocus="'showElement'">Special rates and benefits to the employees of our 100+ partner organizations.</p>
                    <h4 class="f3 tc red hidden hidden-bottom" v-infocus="'showElement'">Corporate Wellness</h4>
                </div>
                <div class="w-100 w-third-ns pa3 mr2">
                    <img src="../assets/Personal.png" alt="">
                    <p class="tc f6 pa3 hidden hidden-bottom muli b" v-infocus="'showElement'">Our training staff is ready to create a game plan for you to achieve all of your fitness goals.</p>
                    <h4 class="f3 tc red hidden hidden-bottom" v-infocus="'showElement'">Personal Training</h4>
                </div>
            </div>
        </div>
        <div class="h-100 bg-near-white fl bg-texture">
            <div class="fl w-100 flex flex-column items-center pt3 mt5 mb5">
                <h1 class="w-50-ns pl0-ns pl3 tc f-subheadline-ns f1 mt0 pt3 pb3 fl bl bw2">Meet the <span class="underline red">team</span></h1>
            </div>
            <div class="w-100 fl">
                <div v-for="trainer in trainersInfo" :key="trainer.key" class="w-100 fl mb5">
                    <img :src="trainer.imgSrc" alt="Trainer Image" class="w-60-ns" :class="trainer.position">
                    <div class="w-30-ns" :class="trainer.position">
                        <p class="pa3 f3 lh-copy  hidden hidden-bottom" v-infocus="'showElement'">{{trainer.greeting}} <span class="red">I'm {{trainer.name}}! </span></p>
                        <p class="pa3 lh-copy  hidden hidden-bottom muli b" v-infocus="'showElement'">{{trainer.desc}}</p>
                    </div>
                </div>
                <div class="w-100 fl flex flex-column items-center mb6">
                    <button class="pl5 pr5 pt3 pb3 white bg-red bw0 grow exo-2">More!</button>
                </div>
            </div>
        </div>

        <div class="h-50 bg-near-black fl w-100 white pa3 bg-lifter bg-fixed">
            <div class="fl w-100 flex flex-column items-center pt3 mt5 mb5">
                <h1 class="w-50-ns pl0-ns pl3 tc f-subheadline-ns f1 mt0 pt3 pb3 fl bl bw2">Join the <span class="underline red">family</span></h1>
            </div>
            <div class="fl w-100 relative flex flex-column items-center h-50">
                <button class="pl5 pr5 pt3 pb3 black bg-white bw0 exo-2 f2-ns f3 absolute grow" @click.prevent="formDisplay = !formDisplay">Become a trainer!</button>
            </div>
        </div>

        <div class="fl w-100 h-50 bg-near-black">
            <div class="w-100 pa2 flex items-center flex-column">
                <img src="../assets/FitBeastInverse.png" alt="FitBeastLogo" class="">
                <p class="lh-copy f6 silver tc">Content and images grabbed from
                    <br>
                    <a href="https://www.freepik.es/" target="blank" class="no-underline silver">Freepik.com</a> - <a href="https://www.pexels.com/" target="blank" class="no-underline silver">Pexels.com</a>
                </p>
            </div>
        </div>
        <transition name="fade">
            <div class="w-100 flex items-center flex-column mt4 z-100 fixed top-0" v-show="formDisplay" style="display:none">
                <form action="" class="pb4 w-90 w-30-ns flex flex-column items-center bg-near-white bb bl br bw2 b--dark-gray">
                    <div class="w-100 flex items-center flex-column bg-dark-gray mb4">
                        <img src="../assets/FitBeastInverse.png" alt="FitBeastLogo" class="">
                    </div>
                    <p class="f6 pa2 w-90 w-80-ns muli b">Leave your contact information and one of our trainers will get in touch with you right away.</p>
                    <input type="text" class="w-90 w-80-ns fl pa3" placeholder="Name" autofocus="autofocus">
                    <input type="email" class="w-90 w-80-ns fl mt3 pa3" placeholder="Email">
                    <button type="button" class="w-30-ns w-80 mt5 mt4-ns pt3 pb3 bg-red ba grow pointer white exo-2" @click.prevent="formDisplay = !formDisplay">Submit</button>
                    <a href="#" class="b f6 no-underline mt3 silver" @click.prevent="formDisplay = !formDisplay">Maybe Later</a>
                </form>
            </div>
        </transition>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      formDisplay: false,
      counter: true,
      trainersInfo: [
        {
          key: 1,
          greeting: 'Hi!',
          name: 'John',
          desc: 'Are you looking for a way to switch up your cross-training? Or do you need motivation to start in the first place? Consider a class with me...',
          imgSrc: require('../assets/John.png'),
          position: 'fl'
        },
        {
          key: 2,
          greeting: 'Hey There!',
          name: 'Jane',
          desc: 'I\'ll guide you to improve your diet quickly with simple, healthy choices. Get strong in the club but get lean in the kitchen!',
          imgSrc: require('../assets/Body.png'),
          position: 'fr'
        }
      ],
      activeBg: 'bg-jane',
      backgrounds: ['bg-jane', 'bg-mike', 'bg-karen'],
      bgCounter: 1
    }
  },
  methods: {
    bgChange: function () {
      setInterval(() => {
        this.activeBg = this.backgrounds[this.bgCounter]
        this.bgCounter === 2 ? this.bgCounter = 0 : this.bgCounter++
      }, 6000)
    }
  },
  directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)
  }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Exo+2:800i');
    @import url('https://fonts.googleapis.com/css?family=Muli');

    .z-100 {
        z-index: 100;
    }
    .h-100 {
        min-height: 100vh;
    }
    .h-50 {
        min-height: 50vh;
    }
    .o-hidden {
        overflow: hidden;
    }
    .bg-jane {
        background: url("../assets/Jane.jpg");
    }
    .bg-mike {
        background: url("../assets/Mike.jpg");
    }
    .bg-karen {
        background: url("../assets/Karen.jpg");
    }
    .bg-lifter {
        background: url("../assets/Lifter.jpg");
    }
    /* .bg-fixed {
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-transition: 2.5s;
        -moz-transition: 2.5s;
        transition: 2.5s;
    } */
    .bg-fixed {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    -webkit-transition: 2.5s;
    -moz-transition: 2.5s;
    transition: 2.5s;
    height: 100%;
    overflow: hidden;
    }
    .exo-2 {
        font-family: 'Exo 2', sans-serif;
    }
    .muli {
        font-family: 'Muli', sans-serif;
    }

    /* FADE IN CLASSES */
    .hidden {
        opacity: 0;
    }

    .hidden-right {
        transform: translate(50px, 0);
    }

    .hidden-left {
        transform: translate(-50px, 0);
    }

    .hidden-bottom {
        transform: translate(0px, 50px);
    }

    .showElement {
        opacity: 1;
        transform: translate(0, 0);
        -webkit-transition: all 0.5s ease-out;
        -moz-transition: all 0.5s ease-out;
        transition: all 0.5s ease-out;
    }
    /* VUE FADE CLASS */
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Fitbeast.vue